import React, { FC, useRef } from 'react'
import { Toolbar, TrainTicketCard } from '~/app/components'
import useToolbarScroll from '~/app/components/common/Toolbar/useToolbarScroll'
import { toValue } from '~/app/utils/react-hook-form-utils'
import { isoToFormat } from '~/app/utils/useIsoToFormat'
import { Layout, ContentContainer, Content } from '~/app/components/layout-style'
import { Notice, User } from '~/app/components/order-list/common/OrderDetailsCommonStyled'
import { TicketPanel } from '~/app/components/order-list/details/TrainTicket/TrainTicketStyled'

/**
 * TrainTicket component
 * author: soojin.oh
 */

// type definitions
type Props = {
  userName: string
  phone: string
  birthDate: string
  createdAt: string
  departureAt: string
  departureStationName: string
  arrivalAt: string
  arrivalStationName: string
  passengerInformation: string
  trainType: string
  goodsReservationNo: string
  seatInformation: [string, string, string][]
  departureDate: string
  stationTrainClassifyCode: string
  onClickBack: () => void
}

// TrainTicket component
const TrainTicket: FC<Props> = function ({
  userName,
  phone,
  birthDate,
  createdAt,
  departureAt,
  departureStationName,
  arrivalAt,
  arrivalStationName,
  passengerInformation,
  trainType,
  goodsReservationNo,
  seatInformation,
  departureDate,
  stationTrainClassifyCode,
  onClickBack,
}) {
  const scrollTarget = useRef<HTMLDivElement>(null)
  const { hasShadow } = useToolbarScroll(scrollTarget)

  return (
    <Layout>
      <Toolbar
        title={'승차권 확인'}
        type={'close'}
        hasShadow={hasShadow}
        onClickBackButton={onClickBack}
      />
      <ContentContainer>
        <Content ref={scrollTarget} style={{ padding: 0, justifyContent: 'flex-start' }}>
          <TicketPanel>
            <TrainTicketCard
              departureAt={departureAt}
              departureStationName={departureStationName}
              stationTrainClassifyCode={stationTrainClassifyCode}
              arrivalAt={arrivalAt}
              arrivalStationName={arrivalStationName}
              trainType={trainType}
              seatInformation={seatInformation}
              departureDate={departureDate}
              passengerInformation={passengerInformation}
              createdAt={createdAt}
            />
            <User>
              <div className={'title'}>예약 정보</div>
              <div>
                <div className={'sub-title'}>성명</div>
                <div className={'description'}>{userName}</div>
              </div>
              <div>
                <div className={'sub-title'}>휴대폰번호</div>
                <div className={'description'}>{toValue.phone(phone)}</div>
              </div>
              <div>
                <div className={'sub-title'}>생년월일</div>
                <div className={'description'}>{isoToFormat(birthDate, 'yyyy.MM.dd')}</div>
              </div>
              <div>
                <div className={'sub-title'}>승차권 예약번호</div>
                <div className={'description'}>{goodsReservationNo}</div>
              </div>
            </User>
          </TicketPanel>
          <Notice>
            <div className={'title'}>이용안내</div>
            <ul>
              <li>해당 승차권은 한국철도에서 인증받았습니다.</li>
              <li>출발역 전광판에서 타는 곳을 확인하세요.</li>
              <li>기차 탑승 시 해당 승차권을 사용해 주세요.</li>
              <li>
                승차권 확인은 예약 시 입력한 이용자 정보(성명, 휴대폰 번호, 생년월일)를 기준으로
                확인이 진행됩니다.
              </li>
              <li>
                승차권 환불 및 변경을 원하거나 기타 문의사항은 NOL 고객센터(1644-1346)로 문의하세요.
                (운영시간 오전 7시~다음 날 오후 7시)
              </li>
            </ul>
          </Notice>
        </Content>
      </ContentContainer>
    </Layout>
  )
}

export default TrainTicket
